import * as React from "react";
import Button from "@mui/material/Button";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Stack from "@mui/material/Stack";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const FilterReset = (props) => {
  const { t } = useTranslation();
  return (
    <Stack direction="row-reverse" spacing={2} pt={8}>
      <Button type="submit" variant="contained" startIcon={<FilterAltIcon />}>
        {t("filter")}
      </Button>

      <Button
        variant="outlined"
        startIcon={<RestartAltIcon />}
        onClick={() => {
          props.resetForm();
        }}
      >
        {t("Reset")}
      </Button>
    </Stack>
  );
};
FilterReset.propTypes = {
  cancelBtn: PropTypes.func,
  resetForm: PropTypes.func,
};

export default FilterReset;
